import script from "./BottomComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BottomComponent.vue?vue&type=style&index=0&id=2c673d21&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c673d21"]])

export default __exports__